var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.onClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _vm.dialogType === "add"
            ? _c(
                "el-form-item",
                { attrs: { label: "添加方式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.addWay,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "addWay", $$v)
                        },
                        expression: "form.addWay",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "single" } }, [
                        _vm._v("单个添加"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "batch" } }, [
                        _vm._v("批量导入"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dialogType === "edit" || _vm.form.addWay === "single"
            ? _c(
                "el-form-item",
                { attrs: { label: "风控账号类型：", prop: "accountType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.dialogType === "edit" },
                      model: {
                        value: _vm.form.accountType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "accountType", $$v)
                        },
                        expression: "form.accountType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "phone" } }, [
                        _vm._v("注册的手机号"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "alipay" } }, [
                        _vm._v("关联的支付宝账号"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dialogType === "edit" || _vm.form.addWay === "single"
            ? _c(
                "el-form-item",
                { attrs: { label: "输入账号：", prop: "account" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入要风控的手机号或支付宝账号",
                      disabled: _vm.dialogType === "edit",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.account,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "account", $$v)
                      },
                      expression: "form.account",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dialogType === "edit" || _vm.form.addWay === "single"
            ? _c(
                "el-form-item",
                { attrs: { label: "风控原因：", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.form.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reason", $$v)
                      },
                      expression: "form.reason",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip-text" }, [
                    _vm._v(
                      "常见风控原因参考：恶意维权、违规拉新、恶意刷单、违规套利、其他"
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dialogType === "add" && _vm.form.addWay === "batch"
            ? _c(
                "el-form-item",
                { attrs: { label: "文件导入：", prop: "file" } },
                [
                  !_vm.uploadFile
                    ? _c(
                        "div",
                        { staticClass: "upload-actions" },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              attrs: {
                                action: "/",
                                "auto-upload": false,
                                "on-change": _vm.handleFileChange,
                                "show-file-list": false,
                                accept: ".xls,.xlsx",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    icon: "el-icon-upload2",
                                  },
                                },
                                [_vm._v("导入Excel")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-download",
                              },
                              on: { click: _vm.downloadTemplate },
                            },
                            [_vm._v("下载模板")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.uploadFile
                    ? _c("div", { staticClass: "file-tag" }, [
                        _c("i", { staticClass: "el-icon-document" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "file-name",
                            attrs: { title: _vm.uploadFile.name },
                          },
                          [_vm._v(_vm._s(_vm.uploadFile.name))]
                        ),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-close close-icon",
                          on: { click: _vm.clearFile },
                        }),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.onSubmit },
            },
            [_vm._v("确认")]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.onReset } }, [_vm._v("重置")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }